// Copyright (c) 2026 GUDUUOS INC. All rights reserved.
// Kept dependency-free so an unavailable application chunk cannot hide recovery.
export function renderStartupFailure(container: HTMLElement) {
    let language = document.documentElement.lang || navigator.language || 'en';
    try {language = localStorage.getItem('guduu.language') || language;} catch { /* Storage is optional. */ }
    const copy = language.startsWith('zh') ? ['暫時無法載入 GuDuu', '請檢查連線，再重新載入此頁面。', '重新載入'] :
        language.startsWith('ja') ? ['GuDuu を読み込めませんでした', '接続を確認して、このページを再読み込みしてください。', '再読み込み'] :
            language.startsWith('ko') ? ['GuDuu를 불러올 수 없습니다', '연결을 확인한 후 이 페이지를 새로고침하세요.', '새로고침'] :
                ['GuDuu could not load', 'Check your connection, then reload this page.', 'Reload'];
    const panel = document.createElement('section');
    panel.className = 'guduu-startup-failure';
    panel.setAttribute('role', 'alert');
    panel.tabIndex = -1;
    const title = document.createElement('h2');
    title.textContent = copy[0];
    const description = document.createElement('p');
    description.textContent = copy[1];
    const retry = document.createElement('a');
    retry.href = window.location.href;
    retry.textContent = copy[2];
    retry.onclick = (event) => {event.preventDefault(); window.location.reload();};
    panel.append(title, description, retry);
    container.replaceChildren(panel);
    document.getElementById('initialPageLoadingScreen')?.remove();
    panel.focus();
}

export function showStartupFailure() {
    // A membership-loss recovery page takes precedence over a late startup error.
    if (document.getElementById('guduu-workspace-recovery')) return;
    const root = document.getElementById('root');
    if (root) renderStartupFailure(root);
}

// A deadline exposes failure; it does not mark work ready or replay any operation.
export async function waitForStartup<T>(work: Promise<T>): Promise<T> {
    let timer: ReturnType<typeof setTimeout> | undefined;
    try {
        return await Promise.race([work, new Promise<never>((_resolve, reject) => {
            timer = setTimeout(() => reject(new Error('Startup timed out')), 30000);
        })]);
    } finally {
        if (timer) clearTimeout(timer);
    }
}
